// extracted by mini-css-extract-plugin
export default {"mtgrid":"UserDetails_mtgrid__ZX7At"};